// Opening times toggle
const handleOpeningTimesToggle = (): void => {
  const openingTimesHeaders = document.querySelectorAll<HTMLElement>('.opening-times-header');
  
  openingTimesHeaders.forEach((header) => {
    header.addEventListener('click', (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      
      const parent = header.closest('.opening-times');
      if (parent) {
        parent.classList.toggle('active');
        
        const detailsElement = parent.querySelector<HTMLElement>('.opening-times-details');
        if (detailsElement) {
          detailsElement.classList.toggle('is-open');
        }
      }
    });
  });
};

// My Account disclosure: each toggle's aria-controls names the menu it opens.
const handleAccountToggle = (): void => {
  const accountToggles = document.querySelectorAll<HTMLButtonElement>('.js-account-toggle');

  const getMenu = (toggle: HTMLButtonElement): HTMLElement | null =>
    document.getElementById(toggle.getAttribute('aria-controls') ?? '');

  const setOpen = (toggle: HTMLButtonElement, open: boolean): void => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.classList.toggle('is-open', open);
    getMenu(toggle)?.classList.toggle('is-open', open);
  };

  accountToggles.forEach((toggle) => {
    const container = toggle.closest<HTMLElement>('.my-account-button');

    toggle.addEventListener('click', (e: Event) => {
      e.stopPropagation();

      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setOpen(toggle, open);

      if (!open) {
        return;
      }

      const getInTouchContent = document.getElementById('getInTouchContent');
      const getInTouchTrigger = document.getElementById('getInTouchTrigger');
      if (getInTouchContent && getInTouchContent.classList.contains('is-open')) {
        getInTouchContent.classList.remove('is-open');
        if (getInTouchTrigger) {
          getInTouchTrigger.setAttribute('aria-expanded', 'false');
        }

        const openingTimesParent = document.querySelector('.opening-times');
        const openingTimesDetails = document.querySelector('.opening-times-details');
        if (openingTimesParent) openingTimesParent.classList.remove('active');
        if (openingTimesDetails) openingTimesDetails.classList.remove('is-open');
      }
    });

    container?.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(toggle, false);
        toggle.focus();
      }
    });

    // Tabbing out past the last account link closes the menu.
    container?.addEventListener('focusout', (e: FocusEvent) => {
      const next = e.relatedTarget as Node | null;
      if (next && !container.contains(next)) {
        setOpen(toggle, false);
      }
    });
  });

  document.addEventListener('click', (e: Event) => {
    const target = e.target as Node;

    accountToggles.forEach((toggle) => {
      if (!toggle.contains(target) && !getMenu(toggle)?.contains(target)) {
        setOpen(toggle, false);
      }
    });
  });
};

const init = (): void => {
  handleOpeningTimesToggle();
  handleAccountToggle();
};

export {
  init
};
